import { Outlet } from 'react-router-dom'
import { useStore } from '../../hooks/useStore'
import Header from './Header'
import ProgressBar from './ProgressBar'
import SyncBanner from '../SyncBanner'

export default function Layout() {
  const { darkMode } = useStore()

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <SyncBanner />
      {/* ProgressBar 已移至 Header 内部实现吸顶 */}

      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
    </div>
  )
}
